import { type ISocketOrderEvent } from '@/types/ISocketOrderEvent';
import { isSocketOrderEvent } from './isSocketOrderEvent';

/**
 * Парсит сырую строку `data:` из SSE-потока Mercure в типизированное
 * событие заказа. Возвращает `null`, если строка не является валидным
 * JSON либо не соответствует ожидаемой форме события.
 *
 * @param raw - строка из поля `data:` события Mercure
 * @returns типизированное событие заказа или `null`
 */
export const parseSocketOrderEvent = (
  raw: string
): ISocketOrderEvent | null => {
  let parsed: unknown;

  try {
    parsed = JSON.parse(raw);
  } catch {
    return null;
  }

  return isSocketOrderEvent(parsed) ? parsed : null;
};
